export const repeatTypes = {
  never: 0,
  daily: 1,
  periodically: 2,
  weekly: 3,
  monthly: 4,
  yearly: 5
};
